import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent implements OnInit {
  @Input() public kind: 1 | 2 | 3 | 4 | 5;
  @Input() public size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  @Input() public color = 'dark-black';
  @Input() public weight = 'regular';
  @Input() public disabled: boolean;
  public classList: Array<string>;

  public ngOnInit(): void {
    this.classList = [
      `title--color-${this.color}`,
      `title--weight-${this.weight}`,
      this.kind ? `title--kind-${this.kind}` : '',
    ];
  }
}
